import React from 'react';
import {  FormControl,  Select,  MenuItem,  Box,  OutlinedInput,  InputAdornment, } from '@mui/material';
import {  FilterList,  CheckCircle,  ViewList  } from '@mui/icons-material';
import { CustomWidthTooltipNoImage } from '../utils/customWidthToolTipUtilNoImage';

const AlertsFilterButton = ({ 
  value = 'all', 
  onChange, 
  className = '',
  style = {}
}) => {
  const filterOptions = [
    {
      value: 'all',
      label: 'Show All',
      icon: <ViewList fontSize="small" />
    },
    {
      value: 'authorized',
      label: 'Authorized Only',
      icon: <CheckCircle fontSize="small" />
    },
    {
      value: 'rogue',
      label: 'Rogue Only',
      icon: <CheckCircle fontSize="small" />
    }
  ];

  const isActive = value !== 'all';
  const toolTip = 'Allows All, Authorized, or Rogue records to be displayed.';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 2 }}>
      <CustomWidthTooltipNoImage title={ toolTip } placement="top" dynamicWidth="250px" dyanmicHeight="25px" >
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <Select
              value={value}
              onChange={(e) => onChange && onChange(e.target.value)}
              className={className}
              displayEmpty
              renderValue={(selected) => {
                const option = filterOptions.find(opt => opt.value === selected);
                return option ? option.label : '';
              }}
              input={
                <OutlinedInput
                  startAdornment={
                    <InputAdornment position="start">
                      <FilterList sx={{ color: '#cccccc', fontSize: 20 }} />
                    </InputAdornment>
                  }
                />
              }
              sx={{
                backgroundColor: '#2a2a2a',
                color: '#ffffff',
                height: '36px',
                fontSize: '0.875rem',
                fontWeight: 500,
                letterSpacing: '0.02em',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                transition: 'all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                borderRadius: '6px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#555555',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#777777',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#999999',
                },
                '& .MuiSelect-icon': {
                  color: '#cccccc',
                },
                '&:hover': {
                  backgroundColor: '#404040',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                },
                ...(isActive && {
                  backgroundColor: '#666666',
                  borderColor: '#888888',
                  '&:hover': {
                    backgroundColor: '#777777',
                  }
                }),
                ...style
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: '#1a1a1a',
                    color: '#ffffff',
                    border: '1px solid #555555',
                    borderRadius: '8px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
                    backdropFilter: 'blur(10px)',
                    '& .MuiMenuItem-root': {
                      fontSize: '0.875rem',
                      fontWeight: 400,
                      py: 1,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      '&:hover': {
                        backgroundColor: '#333333',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#666666',
                        '&:hover': {
                          backgroundColor: '#777777',
                        }
                      }
                    }
                  }
                }
              }}
            >
              {filterOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                    <Box sx={{ color: 'inherit', fontSize: 20, flexShrink: 0 }}>
                      {option.icon}
                    </Box>
                    <Box sx={{ 
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}>
                      {option.label}
                    </Box>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
      </CustomWidthTooltipNoImage>
    </Box>
  );
};

export default AlertsFilterButton;